export default {
  primary: '#37373D', // gray-800
}
